import React , { useState } from "react";
import { Link } from "react-router-dom";
import {
  Mail,
  MapPin,
  Phone,
  Facebook,
  Linkedin,
  Youtube,
  Twitter,
  Instagram,
} from "lucide-react";

const Footer = () => {
  // Inside your component:
const [showDownloadMsg, setShowDownloadMsg] = useState(false);
const [showBlogMsg, setShowBlogMsg] = useState(false);

const handleComingSoon = (setter: React.Dispatch<React.SetStateAction<boolean>>) => {
  setter(true);
  setTimeout(() => setter(false), 2000); // Hides the message after 2 seconds
};
  return (
    // Removed lg:-ml-5 to ensure margin consistency
    <footer className="bg-[#faf9f6] text-gray-700 pt-16 pb-8 text-[18px] font-sans border-t border-gray-200 pr-10">
      {/* Balanced padding-x for consistency on both sides */}
      <div className="max-w-7xl mx-auto px-8 lg:px-12">

        {/* MAIN GRID */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10 mb-12">

          {/* Column 1: Logo */}
          <div className="flex flex-col items-start">
            <div className="w-40 mb-6">
              <img
                src="/logo.png"
                alt="DreamLadder Capital"
                className="w-full h-auto object-contain"
              />
            </div>

            <div className="flex space-x-3 mb-6 text-gray-500">
             <a
    href="https://www.facebook.com/DreamLadderCapital"
    target="_blank"
    rel="noopener noreferrer"
  > <Facebook size={22} className="cursor-pointer hover:text-[#f88f2e]" /> </a>
        <a
    href="https://www.linkedin.com/company/dreamladder-capital/"
    target="_blank"
    rel="noopener noreferrer"
  >       <Linkedin size={22} className="cursor-pointer hover:text-[#f88f2e]" /> </a>
      <a
    href="https://www.youtube.com/@DreamLadderCapital"
    target="_blank"
    rel="noopener noreferrer"
  >        <Youtube size={22} className="cursor-pointer hover:text-[#f88f2e]" /> </a>
  <a
    href="https://x.com/SadaySinha15"
    target="_blank"
    rel="noopener noreferrer"
  >
              <Twitter size={22} className="cursor-pointer hover:text-[#f88f2e]" /> </a>
              <a
    href="https://www.instagram.com/dreamladdercapital"
    target="_blank"
    rel="noopener noreferrer"
  >
              <Instagram size={22} className="cursor-pointer hover:text-[#f88f2e]" /> </a>
            </div>

            <div className="flex gap-3">
               <a
    href="https://play.google.com/store/search?q=dreamladder+capital&&pli=1&c=apps#038;c=apps&#038;hl=en_IN"
    target="_blank"
    rel="noopener noreferrer"
  >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                alt="Google Play"
                className="h-6 cursor-pointer"
              />
              </a>
              <a
    href="https://apps.apple.com/in/app/dreamladder-capital/id1527793478"
    target="_blank"
    rel="noopener noreferrer"
  >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg"
                alt="App Store"
                className="h-6 cursor-pointer"
              />
              </a>
            </div>
            
          </div>

          {/* Column 2: Quick Links */}
          <div>
            <h3 className="text-[22px] font-semibold text-gray-900 mb-6">Quick Links</h3>
            <ul className="space-y-3">
             <li className="footer-btn">
  <a 
    href="https://dreamladdercapital.my-portfolio.co.in/app/#/login" 
    target="_blank" 
    rel="noopener noreferrer"
    className="hover:text-red-600 transition-colors"
  >
    Client Login
  </a>
</li>
             <li 
  className="footer-btn cursor-pointer flex items-center gap-2 relative"
  onClick={() => handleComingSoon(setShowDownloadMsg)}
>
  Download
  {showDownloadMsg && (
    <span className="text-[10px] text-red-600 font-bold animate-pulse">
      (Coming Soon)
    </span>
  )}
</li>

<li 
  className="footer-btn cursor-pointer flex items-center gap-2 relative"
  onClick={() => handleComingSoon(setShowBlogMsg)}
>
  Blogs
  {showBlogMsg && (
    <span className="text-[10px] text-red-600 font-bold animate-pulse">
      (Coming Soon)
    </span>
  )}
</li>
             
              <li>
                <Link to="/calculator" className="footer-link">
                  Financial Calculator
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Our Products */}
          <div>
            <h3 className="text-[22px] font-semibold text-gray-900 mb-6">Our Products</h3>
            <ul className="space-y-3">
              <li className="footer-btn">
  <Link to="/mutual-funds" className="hover:text-red-600 transition-colors">
    Mutual Fund
  </Link>
</li>

<li className="footer-btn">
  <Link to="/pms--aif" className="hover:text-red-600 transition-colors">
    PMS / AIF
  </Link>
</li>

<li className="footer-btn">
  <Link to="/insurance" className="hover:text-red-600 transition-colors">
    Insurance
  </Link>
</li>

{/* Note: I've added a logical path for Structured Products as well */}
<li className="footer-btn">
  <Link to="/structured-products" className="hover:text-red-600 transition-colors">
    Structured Products
  </Link>
</li>
            </ul>
          </div>

          {/* Column 4: Financial Goal */}
          <div>
            <h3 className="text-[22px] font-semibold text-gray-900 mb-6">Financial Goal</h3>
            <ul className="space-y-3">
            <li className="footer-btn">
  <Link to="/calculator" className="hover:text-red-600 transition-colors">
    Education
  </Link>
</li>

<li className="footer-btn">
  <Link to="/calculator" className="hover:text-red-600 transition-colors">
    Marriage
  </Link>
</li>

<li className="footer-btn">
  <Link to="/calculator" className="hover:text-red-600 transition-colors">
    Retirement
  </Link>
</li>

<li className="footer-btn">
  <Link to="/calculator" className="hover:text-red-600 transition-colors">
    SIP
  </Link>
</li>
            </ul>
          </div>

          {/* Column 5: Reach Us (FIXED WRAPPING) */}
          <div>
            <h3 className="text-[22px] font-semibold text-gray-900 mb-6">Reach Us</h3>

            <ul className="space-y-4">
              <li className="flex items-center gap-3">
                <Phone className="text-red-500 w-5 h-5 flex-shrink-0" />
                <span className="whitespace-nowrap">+91 89-0808-2222</span>
              </li>

              <li className="flex items-center gap-3">
                <Mail className="text-red-500 w-5 h-5 flex-shrink-0" />
                <span className="break-all lg:break-normal">info@dreamladdercapital.com</span>
              </li>

              <li className="flex items-start gap-3">
                <MapPin className="text-red-500 w-5 h-5 mt-1 flex-shrink-0" />
                <div className="leading-tight">
                  {/* whitespace-nowrap ensures the name stays on one line */}
                  <p className="font-bold whitespace-nowrap">DreamLadder Capital</p>
                  <p>#20, 10th Floor,</p>
                  {/* Combined City Offices and Ghatkopar (W) */}
                  <p className="whitespace-nowrap">R. City Offices, Ghatkopar (W)</p>
                  <p>Mumbai – 86</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
       {/* ================= REGULATORY DISCLOSURES ================= */}
        <div className="border-t border-gray-300 pt-10 mt-10">
          <div className="text-[12px] text-gray-500 leading-relaxed text-justify space-y-4">
            <p>
              <span className="font-bold text-gray-700">Risk Factors –</span> Investments in Mutual Funds are subject to Market Risks. Read all scheme related documents carefully before investing. Mutual Fund Schemes do not assure or guarantee any returns. Past performances of any Mutual Fund Scheme may or may not be sustained in future. There is no guarantee that the investment objective of any suggested scheme shall be achieved. All existing and prospective investors are advised to check and evaluate the Exit loads and other cost structure (TER) applicable at the time of making the investment before finalizing on any investment decision for Mutual Funds schemes. We deal in Regular Plans only for Mutual Fund Schemes and earn a Trailing Commission on client investments. Disclosure For Commission earnings is made to clients at the time of investments. Option of Direct Plan for every Mutual Fund Scheme is available to investors offering advantage of lower expense ratio. We are not entitled to earn any commission on Direct plans. Hence we do not deal in Direct Plans.
            </p>

            <div className="text-center pt-4 border-t border-gray-200/50">
              <p className="font-semibold text-gray-600">
                AMFI Registered Mutual Funds Distributor | ARN-143182 | Initial Date of Registration: 04/04/2018 | Validity: 03/04/2027
              </p>
              <p className="font-semibold text-gray-600 mt-1">
                APRN Code: APRN05201 | Validity: 06/04/2028
              </p>
            </div>
          </div>
        </div>

        {/* ================= COPYRIGHT & LEGAL LINKS ================= */}
        <div className="mt-10 pb-4 text-center">
          <div className="flex flex-wrap justify-center items-center gap-x-2 gap-y-2 text-[13px] text-gray-600 font-medium">
            <span>©2026 DreamLadder Capital.</span>
            <Link to="/privacy-policy" className="hover:text-red-600 transition-colors">Privacy Policy</Link>
            <span className="text-gray-300">|</span>
            <Link to="/disclaimer" className="hover:text-red-600 transition-colors">Disclaimer</Link>
            <span className="text-gray-300">|</span>
            <Link to="/disclosure" className="hover:text-red-600 transition-colors">Disclosure</Link>
            <span className="text-gray-300">|</span>
           <a 
  href="https://www.sebi.gov.in/filings/mutual-funds.html" 
  target="_blank" 
  rel="noopener noreferrer" 
  className="hover:text-red-600 transition-colors"
>
  SID/SAI/KIM
</a>
            <span className="text-gray-300">|</span>
          <a 
  href="https://www.amfiindia.com/Themes/Theme1/downloads/RevisedCodeofConductforMutualFundDistributors-April2022.pdf " 
  target="_blank" 
  rel="noopener noreferrer" 
  className="hover:text-red-600 transition-colors"
>
  Code of Conduct
</a>
            <span className="text-gray-300">|</span><a 
  href="https://www.sebi.gov.in/sebiweb/home/HomeAction.do?doListing=yes&sid=1&ssid=7&smid=0" 
  target="_blank" 
  rel="noopener noreferrer" 
  className="hover:text-red-600 transition-colors"
>
  SEBI Circulars
</a>
 
            <span className="text-gray-300">|</span>
           <a 
  href="https://www.amfiindia.com/investor-corner/knowledge-center/risks-in-mutual-funds.html" 
  target="_blank" 
  rel="noopener noreferrer" 
  className="hover:text-red-600 transition-colors"
>
  AMFI Risk Factors
</a>
          </div>
        </div>

      </div>

      <style>
        {`
          .footer-btn {
            cursor: pointer;
            transition: color 0.2s;
          }
          .footer-btn:hover,
          .footer-link:hover {
            color: #f88f2e;
          }
        `}
      </style>
    </footer>
  );
};

export default Footer;